import DefaultCarouselButtons from './DefaultButtons'
import FloatingCarrosselButtons from './FloatingButtons'

const CAROUSEL_CONTROLLERS = {
  default: DefaultCarouselButtons,
  floating: FloatingCarrosselButtons,
}
export type CarouselControllers = keyof typeof CAROUSEL_CONTROLLERS

export const getCarouselController = (controller: CarouselControllers = 'default') => {
  const selectedController = CAROUSEL_CONTROLLERS[controller]
  return selectedController
}
